import infoIcon from '@images/warning-black.svg';

const getPrefixMatchAlertBarProps = (
  searchedPrefixes: string[],
  prefixMatchedGenes: string[],
) => {
  const title = `No exact match for '${searchedPrefixes[0]}' ${
    searchedPrefixes.length !== 1 ? 'and more' : ''
  }`;
  const message = `Showing similar results: '${prefixMatchedGenes.join(', ')}'`;

  const icon = infoIcon;

  const className = 'bg-3b-info-light';

  return { title, message, icon, className };
};

const getInvalidGeneAlertBarProps = (searchedInvalidGenes: string[]) => {
  const title = `${searchedInvalidGenes.length} invalid gene${
    searchedInvalidGenes.length !== 1 ? 's' : ''
  }`;
  const message = searchedInvalidGenes.join(', ');

  return { title, message };
};

export { getInvalidGeneAlertBarProps, getPrefixMatchAlertBarProps };
